module.exports = __webpack_public_path__ + "static/media/sortering-opp.970f5f93.svg";